import { gql } from "@stadium/services/apollo-client";

export const destroySession = gql`
  mutation DeleteSession($input: SessionDeleteInput!) @api(name: "users") {
    deleteSession(input: $input) {
      success
    }
  }
`;
